<style lang="scss" scoped>
.fe {
	position: relative;
	top: 3px;
}
table {
	margin-bottom: 60px;
	tr {
		th:first-child {
			padding-left: 40px !important;
		}
		th:last-child {
			padding-right: 40px !important;
		}
	}
}
.padding {
	padding: 20px 40px;
}
</style>

<template>
	<div>
		<app-header>
			<template slot="header">
				<div class="d-flex">
					<h1><i class="fe fe-smartphone" style="margin-right: 15px"></i> Student credentials sender</h1>
					<div class="ml-auto custom-width">
						<!-- <el-button @click="$router.push({name:`communication.log`})">View communication log</el-button> -->
						<el-dropdown @command="toggle">
							<el-button type="plain">
								Toggle selected
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu @command="toggle" slot="dropdown">
								<el-dropdown-item command="select-all">Select all</el-dropdown-item>
								<el-dropdown-item command="unselect-all">Unselect all</el-dropdown-item>
								<el-dropdown-item command="select-previous">Select previously sent</el-dropdown-item>
								<el-dropdown-item command="select-no-previous">Select not previously sent</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-button style="margin-left: 40px" :disabled="!sendTo.length" @click="send" type="success">Send credentials to parents</el-button>
					</div>
				</div>
			</template>
		</app-header>
		<div class="container">
			<div class="main-panel directory">
				<div class="padding">
					<p>
						The following students have been created in Google Sync. Select the students you wish to receive their generated credentials (i.e. email address and
						password) and the parent of whom will receive these by email and/or text message. Please ensure the contact details are correct. Please note that
						the cost of sending credentials to parents is 10p per student.
					</p>
					<p>
						The passwords Wonde will send to any of the selected users parents are only the passwords created when Wonde provisioned the Google Account. As
						such, it may only be appropriate to send these passwords out upon initial setup of the school’s G Suite infrastructure.
					</p>
					<el-input placeholder="Search students" v-model="term" prefix-icon="el-icon-search"></el-input>
				</div>
				<empty v-if="!$apollo.loading && !communicationRows.length" message="You have no users ready to send credentials for."></empty>
				<table v-if="$apollo.loading || communicationRows.length" class="table" v-loading="$apollo.loading">
					<thead>
						<tr>
							<th>Students details</th>
							<th>Parent details</th>
							<th>Parent email</th>
							<th>Parent phone</th>
							<th style="text-align: center">
								Swap
								<br />parent
							</th>
							<th style="text-align: center">
								Sent
								<br />previously
							</th>
							<th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<CommuncationRow v-for="row in communicationRows" :key="row.id" :user="row"></CommuncationRow>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag";
import CommuncationRow from "./CommuncationRow";
import Fuse from "fuse.js";
import { cloneDeep, map, filter, find } from "lodash";

export default {
	components: {
		CommuncationRow,
	},

	data() {
		return {
			term: null,
		};
	},

	apollo: {
		Communication: {
			query: gql`
				{
					Communication {
						id
						forename
						surname
						email
						previousComms
						Parents {
							id
							contact_court_order
							contact_email
							contact_forename
							contact_id
							contact_parental_responsibility
							contact_phone
							contact_priority
							contact_surname
						}
					}
				}
			`,
			error(error) {
				if (find(error.graphQLErrors, { message: "Permission error" })) {
					alert(
						"Google sync is missing permissions to access data at your school, please go to edu.wonde.com and activate all optional permissions relating to contacts to use this feature."
					);
					this.$router.push("/");
				}
			},
			update: (data) =>
				map(cloneDeep(data.Communication), (row) => {
					return {
						...row,
						selected: false,
						selectedParentRow: row.Parents[0],
					};
				}),
		},
	},

	computed: {
		communicationRows() {
			if (this.term) {
				const options = {
					keys: ["forename", "surname", "email"],
				};

				const fuse = new Fuse(this.Communication, options);

				return fuse.search(this.term);
			} else {
				return this.Communication;
			}
		},
		sendTo() {
			return map(filter(this.Communication, { selected: true }), (row) => {
				return {
					id: row.id,
					contact_id: row.selectedParentRow.contact_id,
					email: row.selectedParentRow.contact_email,
					phone: row.selectedParentRow.contact_phone,
				};
			});
		},
	},

	methods: {
		toggle(command) {
			switch (command) {
				case "select-all":
					this.Communication.forEach((row) => {
						row.selected = true;
					});
					break;
				case "select-no-previous":
					this.Communication.forEach((row) => {
						if (!row.previousComms) {
							row.selected = true;
						}
					});
					break;
				case "select-previous":
					this.Communication.forEach((row) => {
						if (row.previousComms) {
							row.selected = true;
						}
					});
					break;
				case "unselect-all":
					this.Communication.forEach((row) => {
						row.selected = false;
					});
					break;
			}
		},
		async send() {
			if (this.sendTo.length == 0) {
				this.$message.error("You have not selected any users");
				return;
			}

			const count = await this.$apollo.mutate({
				mutation: gql`
					mutation SaveCommunication($users: [ComsSelection!]) {
						SaveCommunication(users: $users, calculatePriceOnly: true)
					}
				`,
				variables: {
					users: this.sendTo,
				},
			});
			console.log("send -> count", count.data.SaveCommunication);

			var formatter = new Intl.NumberFormat("en-UK", {
				style: "currency",
				currency: "GBP",
			});

			await this.$confirm(
				`Sending student credentials by email and text message to parents will be charged directly to the school. The cost for those selected is ${formatter.format(
					count.data.SaveCommunication
				)}+VAT`,
				"Send student credentials",
				{
					confirmButtonText: "Confirm",
					cancelButtonText: "Cancel",
				}
			);

			const result = await this.$apollo.mutate({
				mutation: gql`
					mutation SaveCommunication($users: [ComsSelection!]) {
						SaveCommunication(users: $users, calculatePriceOnly: false)
					}
				`,
				variables: {
					users: this.sendTo,
				},
			});
			console.log("send -> result", result);

			this.$message.success("Sending password communication");

			setTimeout(() => {
				location.reload();
			}, 2000);
		},
		toggleAll() {
			this.Communication.forEach((row) => {
				row.selected = !row.selected;
			});
		},
	},
};
</script>